import RegisterQuiz from "./register-quiz";
import RegisterQuizFullwidth from "./register-quiz-fullwidth";
export default RegisterQuiz;
export { RegisterQuizFullwidth };